module.exports = __webpack_public_path__ + "static/media/sib.dc647436.svg";